import React from "react";
import { Link, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles/";
import Icon from "@material-ui/core/Icon/";
import IconButton from "@material-ui/core/IconButton/";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import ConfirmChangeStatusDialog from "./ConfirmChangeStatusDialog";
import { mutantColors } from "../../assets/styles/themes/default";
// TODO: remover comentário abaixo
/* eslint-disable no-unused-vars */
import toggleOnIcon from "../../assets/icons/icon-toggle-on.svg";
import toggleOffIcon from "../../assets/icons/icon-toggle-off.svg";
import {
	DeleteIcon,
	EditIcon,
	MailIcon,
	PlayIcon,
	StopIcon,
	WarningIcon,
	WarningIcon16,
	WarningIconDisabled,
	WarningIconDisabled16
} from "../../components/IconsSVG";
import { Refresh, Backspace, PictureAsPdf } from "@material-ui/icons";
import ConfirmRevisedDialog from "./ConfirmRevisedDialog";

const useStyles = makeStyles(() => ({
	button: {
		margin: "0 2px",
		"& svg": {
			fill: mutantColors.d_blue_4
		},
		"&#disabled": {
			"& svg": {
				fill: "#afafaf !important"
			}
		}
	},
	div: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "center"
	}
}));

export default function CrudActions({
	actions,
	onConfirmDelete,
	onConfirmClear,
	onConfirmRevert,
	onConfirmChangeStatus,
	disabledEmails,
	module,
	id,
	obj,
	onViewDetails,
	onViewCertified,
	onConfirmResendEmail,
	onConfirmRevised,
	onConfirmPlay,
	onConfirmStop,
	handleEdit,
	pageOrigin,
	reason,
	setReason
}) {
	const classes = useStyles();
	const history = useHistory();
	const shouldShowEditButton = (pathname) => {
    const validEditPaths = [
        "/dashboard/projects",
        "/dashboard/prompts",
        "/dashboard/users",
        "/dashboard/apikeys",
				"/dashboard/providers",
				"/dashboard/presets"
    ];
    const isProjectPrompt = pathname.match(/^\/dashboard\/projects\/\d+\/prompts$/);
    return validEditPaths.some(path => pathname.startsWith(path)) || isProjectPrompt;
};

	const [confirmDelete, setConfirmDelete] = React.useState(false);
	const [confirmClear, setConfirmClear] = React.useState(false);
	const [confirmRevert, setConfirmRevert] = React.useState(false);
	const [confirmRevision, setConfirmRevision] = React.useState(false);
	const [confirmChangeStatus, setConfirmChangeStatus] = React.useState(false);
	const [confirmResend, setConfirmResend] = React.useState(false);
	const [confirmPlay, setConfirmPlay] = React.useState(false);

	function toggleConfirmDialog(state) {
		setConfirmDelete(state);
	}

	function toggleConfirmRevertDialog(state) {
		setConfirmRevert(state);
	}

	function toggleConfirmClearDialog(state) {
		setConfirmClear(state);
	}

	function toggleChangeStatusDialog(state) {
		setConfirmChangeStatus(state);
	}

	function toggleConfirmRevisionDialog(state) {
		setConfirmRevision(state);
	}

	function togglePlayDialog(state) {
		setConfirmPlay(state);
	}

	function toggleResendDialog(state) {
		setConfirmResend(state);
	}

	function handleConfirmDelete(id) {
		toggleConfirmDialog(false);
		onConfirmDelete(id);
	}

	function handleConfirmClear(id) {
		toggleConfirmClearDialog(false);
		onConfirmClear(id);
	}

	function handleConfirmRevert(id) {
		toggleConfirmRevertDialog(false);
		onConfirmRevert(id);
	}

	function handleConfirmRevised(id) {
		toggleConfirmRevisionDialog(false)
		onConfirmRevised(id);
	}

	function handleChangeStatus(id) {
		toggleChangeStatusDialog(false);
		onConfirmChangeStatus(id);
	}

	function handlePlay(obj) {
		togglePlayDialog(false);
		onConfirmPlay(obj);
	}

	function handleViewDetails(obj) {
		onViewDetails(obj);
	}

	function handleEditObj(obj) {
		handleEdit(obj);
	}

	function handleViewCertified(obj) {
		onViewCertified(obj);
	}

	function handleResendMail(obj) {
		toggleResendDialog(false);
		onConfirmResendEmail(obj);
	}

	const createToggleButton = stepNumber => (
		<span data-tour={`step-${stepNumber}`}>
			<ConfirmChangeStatusDialog
				open={confirmChangeStatus}
				closeDialog={() => setConfirmChangeStatus(false)}
				confirm={() => handleChangeStatus(obj)}
				message={`Deseja marcar esse prompt como inválido?`}
				title="Confirmação"
				reason={reason}
				setReason={setReason}
			/>

			{obj && !obj.invalidated ? (
				<IconButton
					size="small"
					className={classes.button}
					title="Invalidar prompt"
					onClick={() => toggleChangeStatusDialog(true)}
				>
					<WarningIcon16 />
				</IconButton>
			) : (
				<IconButton
					size="small"
					className={classes.button}
					title="Prompt invalidado"
				>
					<WarningIconDisabled16 />
				</IconButton>
			)}
		</span>
	);

	const createEditButton = stepNumber => (
		<span data-tour={`step-${stepNumber}`}>
			{
				module === 'users' && !!disabledEmails.includes(obj?.email) ?
					<IconButton
						size="small"
						className={classes.button}
						title="Não é possível editar perfil base"
						id="disabled"
					>
						<EditIcon />
					</IconButton>
					:
					<Link
						to={`/dashboard/${module}/${id}/edit${pageOrigin ? "?origin=" + pageOrigin : ""
							}`}
					>
						<IconButton
							size="small"
							className={classes.button}
							title="Editar registro"
						>
							<EditIcon />
						</IconButton>
					</Link>
			}
		</span>
	);

	return (
		<div className={classes.div}>
			{/* TODO: Remover comentários abaixo */}
			{actions && actions.includes("toggle") && (
				<>
					{history.location.pathname.startsWith("/dashboard/projects") &&
						history.location.pathname.endsWith("prompts") &&
						createToggleButton(5)}
				</>
			)}

			{actions && actions.includes("revise") && (
				<>
					<ConfirmRevisedDialog
						open={confirmRevision}
						closeDialog={() => toggleConfirmRevisionDialog(false)}
						confirm={() => handleConfirmRevised(id)}
					/>
					<IconButton
						size="small"
						className={classes.button}
						title="Marcar como revisado"
						disabled={obj.isRevised}
						onClick={() => toggleConfirmRevisionDialog(true)}
					>
						<img src={obj.isRevised ? toggleOnIcon : toggleOffIcon} alt="Inativar" />
					</IconButton>
				</>
			)}

			{actions && actions.includes("edit") && shouldShowEditButton(history.location.pathname) && createEditButton(11)}
			{actions && actions.includes("revert") && (
				<>
					<ConfirmDeleteDialog
						open={confirmRevert}
						title="Confirmação"
						message="Deseja realmente reverter a linha de registro?"
						closeDialog={() => toggleConfirmRevertDialog(false)}
						confirm={() => handleConfirmRevert(id)}
					/>

					<IconButton
						size="small"
						className={classes.button}
						title="Reverter registro original da linha"
						onClick={() => toggleConfirmRevertDialog(true)}
					>
						<Refresh fontSize="small" />
					</IconButton>
				</>
			)}

			{actions && actions.includes("clear") && (
				<>
					<ConfirmDeleteDialog
						open={confirmClear}
						title="Confirmação"
						message="Deseja realmente limpar a linha de registro?"
						closeDialog={() => toggleConfirmClearDialog(false)}
						confirm={() => handleConfirmClear(id)}
					/>

					<IconButton
						size="small"
						className={classes.button}
						title="Limpar registros da linha"
						onClick={() => toggleConfirmClearDialog(true)}
					>
						<Backspace fontSize="small" />
					</IconButton>
				</>
			)}

			{actions && actions.includes("play") && (
				<>
					<ConfirmChangeStatusDialog
						open={confirmPlay}
						confirm={() => handlePlay(obj)}
						closeDialog={() => togglePlayDialog(false)}
						message="Deseja iniciar um novo timer, contendo as mesmas informações de Cliente, Projeto, Atividade e Demanda?"
						hideTitle
					/>
					<IconButton
						color="primary"
						size="small"
						title="Iniciar timer"
						className={classes.button}
						onClick={() => togglePlayDialog(true)}
					>
						<PlayIcon />
					</IconButton>
				</>
			)}

			{actions && actions.includes("stop") && (
				<IconButton
					color="primary"
					size="small"
					title="Iniciar timer"
					className={classes.button}
					onClick={() => onConfirmStop(obj)}
				>
					<StopIcon />
				</IconButton>
			)}

			{actions && actions.includes("edit-form") && (
				<IconButton
					onClick={() => handleEditObj(obj)}
					size="small"
					className={classes.button}
					title="Editar registro"
				>
					<EditIcon />
				</IconButton>
			)}

			{actions && actions.includes("delete") && (
				<>
					<ConfirmDeleteDialog
						open={confirmDelete}
						closeDialog={() => toggleConfirmDialog(false)}
						confirm={() => handleConfirmDelete(id)}
					/>

					<IconButton
						size="small"
						className={classes.button}
						title="Excluir registro"
						onClick={() => toggleConfirmDialog(true)}
					>
						<DeleteIcon />
					</IconButton>
				</>
			)}

			{actions && actions.includes("resend") && (
				<>
					<ConfirmChangeStatusDialog
						open={confirmResend}
						closeDialog={() => setConfirmResend(false)}
						confirm={() => handleResendMail(obj)}
						message="Deseja reenviar um email de ativação para o usuário selcionado?"
						title="Confirmação"
					/>

					<IconButton
						size="small"
						color="inherit"
						className={classes.button}
						title="Reenviar email de confirmação"
						onClick={() => toggleResendDialog(true)}
					>
						<MailIcon />
					</IconButton>
				</>
			)}

			{actions && actions.includes("show") && (
				<IconButton
					// color='primary'
					onClick={() => handleViewDetails(obj)}
					size="small"
					className={classes.button}
					title="Visualizar detalhes"
				>
					<Icon fontSize="small">visibility</Icon>
				</IconButton>
			)}

			{actions && actions.includes("certified") && (
				<IconButton
					onClick={() => handleViewCertified(obj)}
					size="small"
					className={classes.button}
					title="Baixar certificado em PDF"
				>
					<PictureAsPdf fontSize="small" />
				</IconButton>
			)}
		</div>
	);
}
